export { default as Swagger1Loader } from './swagger1Loader'
export { swagger2Loader as Swagger2Loader } from './swagger2Loader'
export { openAPI3Loader as OpenAPI3Loader } from './openAPI3Loader'



// WEBPACK FOOTER //
// ./src/infrastructure/loaders/index.js